import {StyleSheet, css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {GRAY_DARKER, NEAR_BLACK} from 'ui-library/Colors';

/**
 * This component is used to render the name of a row header with units in the experiment plan table.
 * Also, solves the problem of having two different styling requirements for the name and the units.
 *
 */
export function ProcedureExperimentRowLabel(props: {name: string; unit?: string}): JSX.Element {
  return (
    <span className="mediocre-tableEditable-axisCell-label-text">
      <span
        className={classNames([
          'mediocre-tableEditable-axisCell--header',
          css(styles.parameterValueCellName),
        ])}
      >
        {props.name}
      </span>
      {props.unit && (
        <span
          className={classNames([
            'u-tiny-padding-left',
            'mediocre-tableEditable-axisCell--fontWeightRegular',
            css(styles.parameterUnitCellName),
          ])}
        >{`(${props.unit})`}</span>
      )}
    </span>
  );
}

const styles = StyleSheet.create({
  parameterValueCellName: {
    color: NEAR_BLACK,
    fontWeight: 400,
  },
  parameterUnitCellName: {
    fontWeight: 400,
    color: GRAY_DARKER,
  },
});
